import { FlexDirectionWrapper } from '../../../../../../components/StyledComponents';
import { numberLocale } from '../../../../../../utils/mask';
import xlsImagem from '../../../../../../images/xls.png';
import Spinner from 'react-spinner-material';
import { TableAdminReports } from '../../../../../../components/TableAdmin/TableAdminReports';
import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { ExcelExportAdmin } from '../../../../../../components/ExcelExportAdmin';
import { RiCameraLine, RiCheckboxCircleFill, RiRoadMapLine } from 'react-icons/ri';

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const TabPanelAtendimento = ({
  paginationFilters,
  columns = [],
  isLoading,
  data,
  isLoadingXLS,
  onClickExportExcel,
  typeFilters,
  tabIndex,
  index = 0,
  handleOrderClick,
  handleInputPageChange,
  handlePageChange,
  onLinesPerPageChange,
  isCsv = false,
  isExcel = false,
  showMap = false,
  filenameExport = '',
  handleClickShowMap = () => { },
  handleClickValidarEmLote,
  handleClickGallery,
}) => {

  return (
    <TabPanel value={tabIndex} index={index}>
      <FlexDirectionWrapper
        style={{
          justifyContent: 'space-between',
          marginTop: '12px',
        }}
      >
        <>
          <p style={{ fontWeight: 'bold', color: '#00ccff' }}>
            {data?.totalElements ? numberLocale(data?.totalElements) : 0}{' '}
            <strong className="find-results"> resultados encontrados</strong>
          </p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignSelf: 'end',
              justifyContent: 'space-between',
            }}
          >

              {!!handleClickGallery && (
              <div style={{ padding: '0px 50px' }}>
                  <div
                      style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                      }}
                      onClick={handleClickGallery}
                  >
                      <RiCameraLine
                          size={32}
                          color="#88BF61"
                      />
                      <p style={{ color: '#88BF61' }}>Galeria de imagens</p>
                  </div>
              </div>
          )}


            {!!showMap && (
              <div style={{ padding: '0px 50px' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <RiRoadMapLine
                    size={32}
                    color="#88BF61"
                    onClick={handleClickShowMap}
                  />
                  <p style={{ color: '#88BF61' }}>Ver no Mapa</p>
                </div>
              </div>
            )}

              {!!handleClickValidarEmLote && (
                  <div
                      onClick={handleClickValidarEmLote}
                      style={{
                          cursor: 'pointer',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: 'auto 24px'
                      }}
                  >
                      <div
                          style={{
                              color: '#0057d9',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginBottom: '4px',
                          }}
                      >
                          <RiCheckboxCircleFill size={24}  color={'#0057d9'}/>
                      </div>
                      <span style={{ color: '#0057d9', fontSize: '12px' }}>Validar em lote</span>
                  </div>
              )}

            {!!isCsv || !!isExcel ? (
              <ExcelExportAdmin
                filename={filenameExport}
                handleDataCallback={onClickExportExcel}
                isCsv={isCsv}
              />
            ) : (
              <>
                {!isLoadingXLS && (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={onClickExportExcel}
                  >
                    <img
                      style={{ width: '3.1rem' }}
                      className="xls"
                      alt="imagem"
                      src={xlsImagem}
                    />
                  </div>
                )}

                {!!isLoadingXLS && (
                  <Spinner
                    radius={40}
                    color={'#00ccff'}
                    stroke={2}
                    visible={true}
                  />
                )}
              </>
            )}
          </div>
        </>
      </FlexDirectionWrapper>

      <TableAdminReports
        data={data}
        columnAction={'actions'}
        paginationFilters={paginationFilters}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={columns}
        isLoading={isLoading}
        tableColor={'#00ccff'}
        lineColor={'rgb(248,251,255, 0.9)'}
        onLinesPerPageChange={onLinesPerPageChange}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        handleOrderClick={handleOrderClick}
        onInputPageChange={handleInputPageChange}
        typeFilters={typeFilters}
      />
    </TabPanel>
  );
};
